var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-jumbotron",
        { attrs: { fluid: "" } },
        [
          _c("template", { slot: "lead" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  !!_vm.$store.state.currentModuleSession
                    ? _vm.$store.state.currentModuleSession.moduleName
                    : null
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "\n        Room: " +
                _vm._s(
                  !!_vm.$store.state.currentModuleSession
                    ? _vm.$store.state.currentModuleSession.roomId
                    : null
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              " Time:\n        " +
                _vm._s(
                  !!_vm.$store.state.currentModuleSession
                    ? _vm.$store.state.currentModuleSession.sessionTimeRaw
                    : null
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "\n        TotalSeat: " +
                _vm._s(
                  !!_vm.$store.state.currentModuleSession
                    ? _vm.$store.state.currentModuleSession.seatTotal
                    : null
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "\n        Trainer: " +
                _vm._s(
                  !!_vm.$store.state.currentModuleSession
                    ? _vm.$store.state.currentModuleSession.trainerName
                    : null
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "\n        Language: " +
                _vm._s(
                  !!_vm.$store.state.currentModuleSession
                    ? _vm.$store.state.currentModuleSession.language
                    : null
                ) +
                "\n    "
            )
          ]),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "2" } }, [_vm._v("Module Name")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-select", {
                    attrs: { type: "text", options: _vm.moduleName },
                    model: {
                      value: _vm.moduleInfo.moduleName,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleInfo, "moduleName", $$v)
                      },
                      expression: "moduleInfo.moduleName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "2" } }, [_vm._v("Room ID")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-select", {
                    attrs: { type: "text", options: _vm.roomId },
                    model: {
                      value: _vm.moduleInfo.roomId,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleInfo, "roomId", $$v)
                      },
                      expression: "moduleInfo.roomId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "2" } }, [_vm._v("Session Time")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "no-ssr",
                    [
                      _c("vue-ctk-date-time-picker", {
                        attrs: {
                          label: "Choose Session Time",
                          formatted: "DD-MM-YYYY HH:mm",
                          "minute-interval": 5,
                          color: "#184167",
                          "enable-button-validate": "",
                          "min-date": "2017-01-01",
                          "max-date": "2030-12-31"
                        },
                        model: {
                          value: _vm.moduleInfo.sessionTimeRaw,
                          callback: function($$v) {
                            _vm.$set(_vm.moduleInfo, "sessionTimeRaw", $$v)
                          },
                          expression: "moduleInfo.sessionTimeRaw"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "8" } }, [
                _c("p", [
                  _vm._v(
                    "seatTaken: " +
                      _vm._s(
                        !!_vm.$store.state.currentModuleSession
                          ? _vm.$store.state.currentModuleSession.seatTaken
                          : -1
                      )
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "2" } }, [_vm._v("Total Seats")]),
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c("b-form-select", {
                    attrs: { type: "text", options: _vm.seatTotal },
                    model: {
                      value: _vm.moduleInfo.seatTotal,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleInfo, "seatTotal", $$v)
                      },
                      expression: "moduleInfo.seatTotal"
                    }
                  })
                ],
                1
              ),
              _c("b-col", { attrs: { sm: "2" } }, [_vm._v("Language")]),
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c("b-form-select", {
                    attrs: { type: "text", options: _vm.languages },
                    model: {
                      value: _vm.moduleInfo.language,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleInfo, "language", $$v)
                      },
                      expression: "moduleInfo.language"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "2" } }, [_vm._v("Trainer Name")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.moduleInfo.trainerName,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleInfo, "trainerName", $$v)
                      },
                      expression: "moduleInfo.trainerName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "2" } }),
              _c(
                "b-col",
                { attrs: { sm: "3" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-success" },
                      on: {
                        click: function($event) {
                          _vm.updateModuleSessionInfo()
                        }
                      }
                    },
                    [_vm._v("\n          Update Session\n        ")]
                  )
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "3" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.resetAll()
                        }
                      }
                    },
                    [_vm._v("\n          Reset Input\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3684cefa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3684cefa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/EditMsModalPanel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3684cefa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/EditMsModalPanel.vue
// module chunks = 6